// @ts-strict-ignore
import {Component, Input} from "@angular/core";
import {BaseAutocompleteDirective} from "../base-autocomplete.directive";
import {Validators} from "@angular/forms";
import {FetchData_TypeMapping} from "../autocomplete.service";
import {SubscriptSizing} from "@angular/material/form-field";

@Component({
	selector: "sim-autocomplete",
	templateUrl: "./sim-autocomplete.component.html",
	styleUrls: ["./sim-autocomplete.component.scss"],
	providers: [{provide: BaseAutocompleteDirective, useExisting: SimAutocompleteComponent}],
	standalone: false,
})
export class SimAutocompleteComponent<T extends keyof FetchData_TypeMapping> extends BaseAutocompleteDirective<T> {
	@Input() errorToken: string;
	@Input() required: boolean | null = null;
	@Input() subscriptSizing: SubscriptSizing = "dynamic";
	protected readonly Validators = Validators;
}
